let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("C44rN")).then(() => parcelRequire('5kPF3'));